import { Button } from 'src/v2/commonComponents/Button';
import { setIsShowRequestUsageTable, useAppDispatch } from 'src/store';

type RequestUsageTriggerProps = {
  isBusiness?: boolean;
};

export const RequestUsageTrigger = ({
  isBusiness,
}: RequestUsageTriggerProps) => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(
      setIsShowRequestUsageTable(isBusiness ? 'business' : 'individual'),
    );
  };

  return (
    <Button color="link" onClick={handleClick}>
      Learn more
    </Button>
  );
};
